/**
 * Local asset paths used throughout the consumer application.
 * Keeping the constants defined individually prevents typos and enables tree-shaking.
 */
const X = "../assets/images/x.svg";
const Bell = "../assets/images/bell.svg";
const Call = "../assets/images/call.svg";
const Copy = "../assets/images/copy.svg";
const Scan = "../assets/images/scan.svg";
const Sort = "../assets/images/sort.svg";
const Star = "../assets/images/star.svg";
const Fb = "../assets/images/facebook.svg";
const Batch = "../assets/images/batch.svg";
const Check = "../assets/images/check.svg";
const Nodata = "../assets/images/nodata.jpg";
const Reload = "../assets/images/reload.svg";
const Ribbon = "../assets/images/ribbon.svg";
const User = "../assets/images/user-icon.svg";
const Edit = "../assets/images/edit-line.svg";
const Humberg = "../assets/images/humberg.svg";
const Insta = "../assets/images/instagram.svg";
const Linkedin = "../assets/images/linkedin.svg";
const Library = "../assets/images/library.svg";
const Message = "../assets/images/message.svg";
const Passkey = "../assets/images/passkey.svg";
const Product = "../assets/images/product.svg";
const Request = "../assets/images/request.svg";
const Strains = "../assets/images/strains.svg";
const Website = "../assets/images/website.svg";
const Threads = "../assets/images/threads.svg";
const Tiktok = "../assets/images/tiktok.svg";
const Welcome = "../assets/images/welcome.svg";
const Backward = "../assets/images/backward.svg";
const Redirect = "../assets/images/redirect.svg";
const Logo = "../assets/images/databis-logo.png";
const UserIcon = "../assets/images/user-menu.svg";
const Analytics = "../assets/images/analytics.svg";
const SearchIcon = "../assets/images/search.svg";
const downArrow = "../assets/images/downArrow.svg";
const NoProduct = "../assets/images/no-product.svg";
const StarFilled = "../assets/images/fillstar.svg";
const BadgeStar = "../assets/images/badgeStar.svg";
const DummyImage = "../assets/images/dummyImage.png";
const FilterIcon = "../assets/images/filter-icon.svg";
const StarRating = "../assets/images/rating-star.svg";
const CheckCircle = "../assets/images/checkcircle.svg";
const InnerLogo = "../assets/images/consumer-logo.png";
const Notification = "../assets/images/notification.svg";
const Announcement = "../assets/images/Announcements.svg";
const HumbergClose = "../assets/images/humberg-cross.svg";
const Manufacturebg = "../assets/images/manufacturebg.svg";
const SuccessSignup = "../assets/images/success-signup.svg";
const NoNotification = "../assets/images/noNotification.svg";
const ReviewPageIcon = "../assets/images/reviewPageIcon.svg";
const NoAnnouncement = "../assets/images/no-announcement.svg";
const DatabisCutLogo = "../assets/images/databis-logo-cut.svg";
const UnderDevelopment = "../assets/images/underDevelopment.jpg";
const BrandDirectory = "../assets/images/brand-directory-black.svg";
const CompoundIcon = "../assets/images/CompoundIcon.svg";
const PrivacyChoiceIcon = "../assets/images/privacychoicesIcon.svg";
const StrainPlaceholderImage = "../assets/images/Strain_Placeholder.png";
const SupportIcon = "../assets/images/support.svg";

//Product Icons
const ProductTypeIcons_Vaporizer =
  "../assets/images/ProductTypeIcons_Vaporizer.svg";
const ProductTypeIcons_Pre_Roll =
  "../assets/images/ProductTypeIcons_Pre-Roll.svg";
const ProductTypeIcons_Topical =
  "../assets/images/ProductTypeIcons_Topical.svg";
const ProductTypeIcons_Tincture =
  "../assets/images/ProductTypeIcons_Tincture.svg";
const ProductTypeIcons_Concentrate =
  "../assets/images/ProductTypeIcons_Concentrate.svg";
const ProductTypeIcons_Other = "../assets/images/ProductTypeIcons_Other.svg";
const ProductTypeIcons_Flower = "../assets/images/ProductTypeIcons_Flower.svg";
const ProductTypeIcons_Edible = "../assets/images/ProductTypeIcons_Edible.svg";
const ProductTypeIcons_Specialty =
  "../assets/images/ProductTypeIcons_Specialty.svg";
const NotFoundImage = "../assets/images/not-found-image.svg";

export const IMAGES = {
  X,
  Fb,
  Bell,
  Call,
  Copy,
  Edit,
  Logo,
  Scan,
  Sort,
  Star,
  User,
  Batch,
  Check,
  Insta,
  Nodata,
  Reload,
  Ribbon,
  Humberg,
  Library,
  Message,
  Passkey,
  Product,
  Request,
  Strains,
  Website,
  Threads,
  Tiktok,
  Welcome,
  Linkedin,
  Backward,
  Redirect,
  UserIcon,
  BadgeStar,
  Analytics,
  InnerLogo,
  NoProduct,
  downArrow,
  DummyImage,
  FilterIcon,
  SearchIcon,
  StarFilled,
  StarRating,
  CheckCircle,
  Announcement,
  HumbergClose,
  Manufacturebg,
  Notification,
  NotFoundImage,
  DatabisCutLogo,
  NoNotification,
  SuccessSignup,
  BrandDirectory,
  CompoundIcon,
  NoAnnouncement,
  ReviewPageIcon,
  UnderDevelopment,
  PrivacyChoiceIcon,
  StrainPlaceholderImage,
  SupportIcon,

  //Product Icons
  ProductTypeIcons_Other,
  ProductTypeIcons_Edible,
  ProductTypeIcons_Flower,
  ProductTypeIcons_Topical,
  ProductTypeIcons_Pre_Roll,
  ProductTypeIcons_Tincture,
  ProductTypeIcons_Specialty,
  ProductTypeIcons_Vaporizer,
  ProductTypeIcons_Concentrate,
} as const;
